import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useAccessTypeStore } from "scenes/Hubly/components/Workspace/components/hooks";

import { FormLayout, Menu, TaskFormIcon } from "..";
import { FormBuilder } from "./components";

export function Form({
  loading,
  hideMenu,
  onUpdate,
  onDelete,
  onAddField,
  children,
  onClick,
  initialAddMode,
  formName,
  onChangeFormName,
}) {
  const { hasAccess } = useAccessTypeStore();
  const [isEditFormNameMode, setEditFormNameMode] = useState(initialAddMode);

  useEffect(() => {
    if (!initialAddMode) {
      setEditFormNameMode(false);
    }
  }, [initialAddMode]);

  return (
    <React.Fragment>
      <FormLayout
        loading={loading && !isEditFormNameMode}
        hideMenu={hideMenu || !hasAccess() || isEditFormNameMode}
        disableHover={!hasAccess()}
        actionIcons={
          <div style={{ floatRight: true }} data-test="add-form-field">
            <TaskFormIcon
              title="Form Field"
              onClick={onAddField}
              icon="clipboard"
            />
          </div>
        }
        popupMenu={
          <Menu>
            {({ closeMenu }) => {
              return (
                <React.Fragment>
                  <Menu.Button
                    onClick={() => {
                      setEditFormNameMode(true);
                      closeMenu();
                    }}
                    content="Edit Form Name"
                    icon="edit"
                  />
                  <Menu.Button
                    onClick={() => {
                      onDelete();
                      closeMenu();
                    }}
                    content="Delete Form"
                    icon="delete"
                  />
                </React.Fragment>
              );
            }}
          </Menu>
        }
      >
        {isEditFormNameMode && !hideMenu ? (
          <FormBuilder
            loading={loading}
            initialValue={formName}
            showActions={!initialAddMode}
            onClose={() => {
              return setEditFormNameMode(false);
            }}
            onSubmit={async (name) => {
              if (!initialAddMode) {
                const resp = await onUpdate(name);
                if (resp) setEditFormNameMode(false);
                return;
              }
              setEditFormNameMode(false);
            }}
            onChange={onChangeFormName}
          />
        ) : (
          <span
            data-test="form-name-container"
            onClick={() => {
              return setEditFormNameMode(true);
            }}
          >
            {formName}
          </span>
        )}
      </FormLayout>
      <div
        data-test="form-content-container"
        style={{ paddingLeft: "2.3em", wordBreak: "break-all" }}
        onClick={onClick}
      >
        {children}
      </div>
    </React.Fragment>
  );
}

Form.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onAddField: PropTypes.func.isRequired,
  children: PropTypes.node,
  loading: PropTypes.bool,
  hideMenu: PropTypes.bool,
  onClick: PropTypes.func,
  formName: PropTypes.string,
  initialAddMode: PropTypes.bool,
  onChangeFormName: PropTypes.func.isRequired,
};

Form.defaultProps = {
  children: null,
  loading: false,
  hideMenu: false,
  initialAddMode: false,
  formName: "",
  onClick: () => {},
};

export default Form;
